/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* DangerousGoodsData
*/
export class DangerousGoodsData {
    'id'?: number;
    'lq': boolean;
    'uNNr'?: string;
    'clazz': string;
    'addedBy': DangerousGoodsDataAddedByEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "lq",
            "baseName": "lq",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "uNNr",
            "baseName": "uNNr",
            "type": "string",
            "format": ""
        },
        {
            "name": "clazz",
            "baseName": "clazz",
            "type": "string",
            "format": ""
        },
        {
            "name": "addedBy",
            "baseName": "addedBy",
            "type": "DangerousGoodsDataAddedByEnum",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return DangerousGoodsData.attributeTypeMap;
    }

    public constructor() {
    }
}


export type DangerousGoodsDataAddedByEnum = "trucker" | "terminal" | "forwarder_operator" ;

